import { render, staticRenderFns } from "./AccountDeletionPage.vue?vue&type=template&id=592f496a&scoped=true"
import script from "./AccountDeletionPage.vue?vue&type=script&lang=js"
export * from "./AccountDeletionPage.vue?vue&type=script&lang=js"
import style0 from "./AccountDeletionPage.vue?vue&type=style&index=0&id=592f496a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f496a",
  null
  
)

export default component.exports